import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styledThemed } from "../../../../../utils/styledThemed";

export const MainWrapper = styledThemed.div`
  border-radius: 5px;
  background-color: #1f242e;
  box-shadow: 0px 0px 4px #e8e8e8;
  margin: 10px 0;
`;

export const ListWrapper = styledThemed.div<{ open: boolean }>`
  text-align: center;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  cursor: pointer;
  justify-content: space-between;
  padding: 5px 10px;
  border: ${(props) => (props.open ? `1px solid ${props.theme.primaryColor}` : "1px solid #fff")};
  border-radius: 5px;
  box-shadow: ${(props) => (props.open ? "0px 4px 9px 1px #1B1E22" : "none")};
  &:hover {
    border: 1px solid ${(props) => props.theme.primaryColor};
  }
  @media screen and (min-width: 576px) {
    padding: 5px 20px;
  }
`;

export const CardWrapper = styledThemed.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
`;

export const IconWrapper = styledThemed.div`
  font-size: 20px;
  display: flex;
  margin-left: 8px;
  justify-content: flex-end;
`;

export const StyledIcon = styledThemed(FontAwesomeIcon)<{ deleteicn?: string }>`
  color: ${(props) =>
    props.deleteicn ? props.theme.primaryActionColor : props.theme.primaryColor};
  flex-wrap: wrap;
  margin: 7px;
  font-size: 17px;
  &:hover {
    cursor: pointer;
  }
`;

export const ToolLogo = styledThemed.div<{ logo: string; invert?: boolean }>`
  width: 25px;
  height: 25px;
  flex-wrap: wrap;
  margin-right: 15px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(${(props) => props.logo});
  ${(props) => props.invert && "filter: invert(1);"}
  @media screen and (min-width: ${(props) => props.theme.xsmall}) {
    width: 40px;
    height: 40px;
  }
`;

export const ConnectionInfo = styledThemed.div`
  font-size: 12px;
  @media screen and (min-width: ${(props) => props.theme.xsmall}) {
    font-size: 14px;
  }
  > span > span {
    display: none;
    @media screen and (min-width: ${(props) => props.theme.xsmall}) {
      display: unset;
    }
  }
`;

export const Heading = styledThemed.div`
  font-size: 12px;
  font-weight: 500;
  flex-wrap: wrap;
  margin: auto 0;
`;
